export function changeDeleteStatus()
{
    return({
        type:"DELETE_STATUS",
    })
}